<template>
  <Modal
    :id="'cmp-royalty-royalty_account-sidewindow-add_contract_form'"
    @cancelled="onCancel"
  >
    <template slot="header"
      >Copy Contract for {{ royalty_account_name }}</template
    >

    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <Dropdown
            :id="'royalty_account_id'"
            class="m2"
            :options="accountsTV"
            :selected="
              accountsTV.find(
                (b) => b.value == contract_copy_info.royalty_account_id
              )
            "
            :placeholder="$t('royalty_account')"
            deselect
            box
            @selectedChange="(b) => onDropdownChange('royalty_account_id', b)"
          ></Dropdown>
          <Dropdown
            :id="'contract_id'"
            class="m2"
            :options="contractsTV"
            :selected="
              contractsTV.find((b) => b.value == contract_copy_info.contract_id)
            "
            :placeholder="$t('contract')"
            deselect
            box
            @selectedChange="(b) => onDropdownChange('contract_id', b)"
          ></Dropdown>
        </div>
      </div>
    </template>
    <div></div>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
      <button class="dt-button v1 s6" @click.stop="onOkClick">Ok</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import InputField from "@plugins/text-field/input-field";
import { AccountsService } from "../../services/accounts.service";
import { accountsRoyaltyGetters } from "../../store/accounts/getters";
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import { accountsRoyaltyActions } from "../../store/accounts/actions";
import { createTV } from "../../../../models/text-value.model";
import * as ActionTypes from "../../store/types";
import { confirmOK } from "../../../../dt-plugins/confirmation/confirmation-common";
export default {
  components: {
    Modal,
    InputField,
  },
  props: ["selectedAccountDetails"],
  data() {
    return {
      contract_copy_info: this.get_copy_contract_info(),
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
      },
      validationResult: {},
    };
  },
  mounted() {
    this.fetchAllRoyaltyAccounts();
  },
  computed: {
    royalty_account_id: function () {
      return this.$route.params.royalty_account_id;
    },
    royalty_account_name: function () {
      return this.selectedAccountDetails?.royalty_account?.royalty_account_name;
    },
    accountsTV: function () {
      return createTV(
        this.contract_copy_info.royalty_accounts,
        "royalty_account_name",
        "royalty_account_id"
      );
    },
    contractsTV: function () {
      return createTV(
        this.contract_copy_info.contracts,
        "contract_name",
        "contract_id"
      );
    },
  },
  methods: {
    ...mapActionObject(storeNS, accountsRoyaltyActions),
    fetchAllRoyaltyAccounts: async function () {
      const result = await AccountsService.fetchAllRoyaltyAccounts();
      console.log("result.data", result.data);
      this.contract_copy_info = {
        ...this.contract_copy_info,
        ...result.data,
      };
    },
    fetchRoyaltyAccountContracts: async function () {
      const result = await AccountsService.fetchRoyaltyAccountContracts({
        royalty_account_id: this.contract_copy_info.royalty_account_id,
      });
      console.log("result.data", result.data);
      this.contract_copy_info = {
        ...this.contract_copy_info,
        ...result.data,
        contract_id:
          result.data.contracts && result.data.contracts.length > 0
            ? result.data.contracts[0].contract_id
            : 0,
      };
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },

    onDropdownChange(name, value) {
      this.contract_copy_info[name] = value.value;
      if (name === "royalty_account_id") {
        this.fetchRoyaltyAccountContracts();
      }
    },
    onOkClick: async function () {
      const resData = await AccountsService.copyContract({
        ...this.contract_copy_info,
        royalty_account_id: this.royalty_account_id,
      });

      AccountsService.get_royalty_account_contracts(
        this.royalty_account_id
      ).then((res) => {
        this[ActionTypes.RoyaltyAccountsContracts.SET.ALL]({
          royalty_account_id: this.royalty_account_id,
          contracts: res.data.contracts || [],
        });
        if (resData.data.total_scale == 1) {
          const confirmationResult = confirmOK(
            "Please Assign Products and Channel to your Scales"
          );
        }
        this.$emit("selected", resData.data.contract.contract_id);
        this.onCancel();
      });
    },
    get_copy_contract_info: function () {
      return {
        contract_name: "",
        royalty_account_id: 0,
        royalty_period_id: 0,
        contract_id: 0,
      };
    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-royalty_account-sidewindow-add_contract_form {
  .form-group .input_box {
    padding: 2px 5px;
  }
  .form-group .label_box {
    padding: 2px 5px;
    color: rgba(70, 70, 70, 0.77);
  }
}
</style>
